
var id = "Recruitment";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"Recruitment\">\n<style type=\"text/css\">\n\t#Recruitment .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M84.6,77.3c1.2-2.2,0.4-5.2-1.8-6.2c-1.8-0.8-3.4-1.4-5.2-2.2c11.4-6.2,19-18.4,19-32.1C96.5,16.6,80.2,0,60,0\n\tS23.3,16.6,23.3,36.5c0,14,7.8,26,19,32.1C23.3,76.1,9.9,94.5,9.9,116c0,2.6,2.2,4.8,4.8,4.8s4.8-2.2,4.8-4.8\n\tc0-22.8,18.8-41.3,41.3-41.3c6.6,0,12.8,1.4,18.8,4.4C80.8,80.5,83.4,79.5,84.6,77.3z M32,36.5C32,21.6,44.4,9,59.6,9\n\tc15,0,27.6,12.4,27.6,27.6S74.8,64.1,59.6,64.1C44.6,64.1,32,51.9,32,36.5z M113.5,100H99.9V86.5c0-2.6-2.2-4.8-4.8-4.8\n\tc-2.6,0-4.8,2.2-4.8,4.8V100H76.8c-2.6,0-4.8,2.2-4.8,4.8c0,2.6,2.2,4.8,4.8,4.8h13.6v13.6c0,2.6,2.2,4.8,4.8,4.8\n\tc2.6,0,4.8-2.2,4.8-4.8v-13.6h13.6c2.6,0,4.8-2.2,4.8-4.8C118.1,102.2,115.9,100,113.5,100z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
